<template>
	<li class="uk-open">
		<button v-if="colorOnly" type="button" class="uk-accordion-title">1. Bed Color</button>
		<button v-else type="button" class="uk-accordion-title">1. Size and color</button>
		<div class="uk-accordion-content">
			<div v-if="!colorOnly" class="input-select" role="radiogroup" aria-labelledby="bedsize-label">
				<p id="bedsize-label" class="option-group-label">Bed Size</p>
				<button v-for="bedSize in bed_sizes" :key="'bsize_option_'+bedSize.id" type="button" role="radio" class="pill-size-option"
						:class="{selected:sizeIsSelected(bedSize.id)}"
						:aria-checked="sizeIsSelected(bedSize.id) ? 'true' : 'false'"
						@click.prevent="setSize(bedSize.id)">
					{{ bedSize.mattress_size.name }}
				</button>
			</div>
			<div v-if="selected_popular_finish && selected_popular_finish.finish" class="color-header">
				Color: <strong>{{ selected_popular_finish.finish.name }}</strong>
				<span v-if="currentUpcharge > 0">(+{{ currentUpcharge | currency }})</span>
			</div>
			<div class="wood-type-container section-overflow qb-finishes-grid" tabindex="0" role="region" aria-label="Wood finishes">
				<div class="uk-child-width-1-4@l uk-grid-small uk-child-width-1-2" uk-grid>
					<div v-for="finish in popular_finishes" :key="'finish_option_'+finish.id">
						<button v-if="finish.finish" type="button" class="wood-type" :class="{'selected' : isActive(finish)}" role="radio" :aria-checked="isActive(finish) ? 'true' : 'false'" :aria-label="`${finish.finish.name} ${finish.wood.name} wood finish`" @click.prevent="onClick(finish)">
							<img :src="imgStyle(finish.finish)" alt="">
							<p class="finish-name">{{ finish.finish.name }}</p>
							<p class="wood-name">{{ finish.wood.name }}</p>
						</button>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "SizeColor",

	props: {
		dataFailure: {
			type: Boolean,
			default: false
		},
		colorOnly: {
			type: Boolean,
			default: false
		}
	},
	components: {},
	data() {
		return {
			selectedSizeId: 0
		}
	},
	mounted() {

	},
	methods: {
		imgStyle(finish) {
			if(finish && finish.image){
				return `${finish.image.webPath}/80`;
			}
			return '';
		},
		setSize(sizeId) {
			this.selectedSizeId = sizeId;
		},
		/**
		 * user clicked on one of the popular finishes
		 * @param  {[type]} finish [description]
		 * @return {[type]}        [description]
		 */
		onClick(selected_finish) {
			this.$store.commit('setSelectedPopularFinish', selected_finish);
			// loop through and find matching wood
			let wood = null;
			for (let w in this.woods) {
				wood = this.woods[w];
				if (wood.id == selected_finish.wood_id) {
					break;
				}
			}
			// save to store.
			this.$store.commit('setSelectedWood', wood);
			setTimeout(() => {
				let finish = null;
				for (let f in this.wood_finishes) {
					finish = this.wood_finishes[f];
					if (finish.id == selected_finish.finish_id) {
						break;
					}
				}
				this.$store.commit('setSelectedFinish', finish);

				// Notify carousel of color change
				window.dispatchEvent(new CustomEvent('bedBuilderColorChange', {
					detail: {
						wood: wood ? wood.name : '',
						finish: finish ? finish.name : '',
					}
				}));
			}, 0);
		},
		/**
		 * see if this is the selected finish.
		 * @param  {[type]}  finish [description]
		 * @return {Boolean}        [description]
		 */
		isActive(finish) {
			if (this.selected_popular_finish == null) return false;
			return this.selected_popular_finish.id == finish.id;
		},
		sizeIsSelected(sizeId) {
			return this.selectedSizeId == sizeId;
		},
		calculateUpcharge(finish) {
			let wallbedUpcharge = finish.finish.grade.wallbed_upcharge;
			wallbedUpcharge = (wallbedUpcharge != null) ? parseFloat(wallbedUpcharge) : 0;
			let currentUpcharge = (this.price_totals.finish_wallbed_upcharge != null) ? parseFloat(this.price_totals.finish_wallbed_upcharge) : 0;
			let currentPrice = parseFloat(this.price_totals.base) + currentUpcharge;
			let optionBase = 0;
			if (this.selected_size) {
				for (let i = 0; i < this.selected_size.prices.length; ++i) {
					let po = this.selected_size.prices[i];
					for (let j = 0; j < po.woods.length; ++j) {
						if (po.woods[j].id == finish.wood.id) {
							optionBase = parseFloat(po.price);
							break;
						}
					}
				}
			}

			let optionPrice = optionBase + wallbedUpcharge;
			let priceChange = optionPrice - currentPrice;
			return priceChange;
		}
	},
	computed: {
		...mapState({
			selected_size: state => state.selected_size,
			bed_sizes: state => state.bed_sizes,
			popular_finishes: state => state.popular_finishes,
			selected_popular_finish: state => state.selected_popular_finish,
			woods: state => state.woods,
			wood_finishes: state => state.wood_finishes,
			price_totals: state => state.totals,
			useDiscounts: state => state.useDiscounts
		}),
		currentUpcharge() {
			if (!this.selected_popular_finish || !this.selected_popular_finish.finish || !this.selected_popular_finish.finish.grade) return 0;
			let upcharge = this.selected_popular_finish.finish.grade.wallbed_upcharge;
			return (upcharge != null) ? parseFloat(upcharge) : 0;
		}
	},
	watch: {
		selectedSizeId(val) {
			for (let i in this.bed_sizes) {
				let row = this.bed_sizes[i];
				if (row.id == val) {
					this.$store.commit('setSelectedSize', row);
					break;
				}
			}
		},
		selected_size(val) {
			if (val && val.id && val.id != this.selectedSizeId) {
				this.selectedSizeId = val.id;
			}
		}
	}
}
</script>

<style scoped>
.color-header {
	font-size: 1.6rem;
	margin-bottom: 0;
	padding-top: 10px;
	color: #333;
}
.color-header span {
	color: #666;
}
.qb-finishes-grid {
	max-height: 180px;
	overflow-y: auto;
}
.wood-type {
	text-align: center;
	border: none;
	background: transparent;
}
.wood-type img {
	width: 100%;
	height: auto;
	aspect-ratio: 1;
	object-fit: cover;
	display: block;
}
.finish-name {
	font-size: 0.8rem;
	font-weight: 500;
	margin: 4px 0 0;
	line-height: 1.2;
}
.wood-name {
	font-size: 0.65rem;
	color: #757575;
	margin: 0;
	line-height: 1.2;
}
</style>